/**
 * Created by lvs on 2019/02/9.
 */
import { setIsBlackUser } from './channel';
import cookies from './cookie';
import { xflowSetLogin } from './pageTrack';
import validate from './validate';

export const Serialize = (data: object, firstCon = '&', secondCon = '=') => Object.keys(data).reduce((prev, key) => {
  const value = data[key];
  if (value != null) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    prev += (prev && firstCon) + key + (String(value) && secondCon + value);
  }
  return prev;
}, '');
interface Dictionary<T> {
  [key: string]: T;
}
export const Deserialize = (value: string, firstCon = '&', secondCon = '=') => {
  const result: Dictionary<string> = {};
  return value.replace('?', '').split(firstCon).reduce((prev, elem) => {
    const index = elem.indexOf(secondCon);
    if (index === -1) {
      prev[elem] = '';
    } else {
      prev[elem.slice(0, index)] = elem.slice(index + 1);
    }
    return prev;
  }, result);
};
export const DeserializeHash = (value: string, firstCon = '&', secondCon = '=') => {
  const result: Dictionary<string> = {};
  return value.replace('#', '').split(firstCon).reduce((prev, elem) => {
    const index = elem.indexOf(secondCon);
    if (index === -1) {
      prev[elem] = '';
    } else {
      prev[elem.slice(0, index)] = elem.slice(index + 1);
    }
    return prev;
  }, result);
};

export const TransformObject = (list: [], key = 'value', value = 'label') => {
  const res: Dictionary<any> = {};
  return list.reduce((prev, elem) => {
    prev[elem[key]] = elem[value];
    return prev;
  }, res);
};

export const TransformEnumArray = (list: [], value = 'value', label = 'label') => {
  const res: Object[] = [];
  return list.reduce((prev, elem) => {
    prev.push({ value: elem[value], label: elem[label] });
    return prev;
  }, res);
};

export const TransfromObjectToArray = (obj) => {
  if (typeof obj !== 'object') {
    return [];
  }
  const res: any[] = [];
  Object.keys(obj).forEach((i) => {
    res.push(obj[i]);
  });
  return res;
};

export const processLoginData = (data) => {
  const {
    token = '',
    userBlackFlag = false,
    bizMap: { realName = '1', maskActId = '', maskusId = '', maskPhone = '' } = {},
    patientDomain: { userId = '', accountId = '', patientName = '', patientCertNo = '', patientBirthday = '', patientGender = ''} = {},
  } = data || {};
  const expire = validate.isFromUnionPay() ? 3 * 24 * 60 : 7 * 24 * 60;
  const longExpire =  30 * 24 * 60;
  token && cookies.set('za_token', token, expire);
  token && cookies.set('za_long_token', token, validate.isFromUnionPay() ? 3 * 24 * 60 : longExpire);
  maskActId && cookies.set('maskActId', maskActId, longExpire);
  maskusId && cookies.set('maskusId', maskusId, longExpire);
  maskPhone && cookies.set('maskPhone', maskPhone, longExpire);
  userId && cookies.set('za_userId', userId, longExpire);
  accountId && cookies.set('za_accountId', accountId, longExpire);
  patientName && cookies.set('za_patientName', patientName, longExpire);
  patientCertNo && cookies.set('za_patientCertNo', patientCertNo, longExpire);
  patientBirthday && cookies.set('za_patientBirthday', patientBirthday, longExpire);
  patientGender && cookies.set('za_patientGender', patientGender, longExpire);
  // 处理用户是否为黑名单逻辑
  setIsBlackUser(userBlackFlag);
  // channelSource && cookies.set('channelSource', channelSource);
  // channelResourceCode && setChannelResourceCode(channelResourceCode);
  if (realName === '1') {
    cookies.set('isRealAuth', 'N', longExpire);
  } else if (realName === '2') {
    cookies.set('isRealAuth', 'Y', longExpire);
  } else if (realName === '3') {
    cookies.set('isRealAuth', 'NY', longExpire);  // 存在多个渠道的实名信息，进入实名页面让用户选择，不需要填写
  }
  xflowSetLogin(maskusId);
};
